import { render, staticRenderFns } from "./quoteDatails.vue?vue&type=template&id=dad354ba&scoped=true"
import script from "./quoteDatails.vue?vue&type=script&lang=js"
export * from "./quoteDatails.vue?vue&type=script&lang=js"
import style0 from "./quoteDatails.vue?vue&type=style&index=0&id=dad354ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad354ba",
  null
  
)

export default component.exports